import React from "react";
import { Backdrop, CircularProgress, Grid, makeStyles, Typography } from "@material-ui/core";
import { useState } from "react";


const useStyles = makeStyles((theme) => ({
    customBackdrop: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 10,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }));

  type CustomBackdropProps = {
    open: boolean;
  message?: string | undefined ;
};
  
  const CustomBackdrop: React.FC<CustomBackdropProps> = ({ open, message}) =>  {
    const classes = useStyles();
    return (
      <Backdrop
        className={classes.customBackdrop}
        open={open}
      >
        <Grid container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
  >
    <CircularProgress color="primary" />
    <Typography>carregando...</Typography>
  </Grid>
      </Backdrop>
    );
  };
  
  export default CustomBackdrop;




// const useStyles = makeStyles((theme) => ({
//     customBackdrop: {
//       position: 'absolute', // Posiciona relativo ao contêiner pai
//       top: 0,
//       left: 0,
//       width: '100%', // Largura total do contêiner
//       height: '100%', // Altura total do contêiner
//       zIndex: 10, // Certifique-se de que fique acima de outros elementos no contêiner
//       backgroundColor: 'rgba(0, 0, 0, 0.5)', // Cor de fundo do Backdrop
//     },
//     container: {
//       position: 'relative', // Define o contêiner como referência
//       width: 300,
//       height: 200,
//       border: '1px solid black',
//       margin: '50px auto',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//     },
//   }));
// type CustomBackdropProps = {
//   opened: boolean;
// };
//  const CustomBackdrop: React.FC<CustomBackdropProps> = ({ opened}) => {
//     const [open, setOpen] = useState(opened);

//   const toggleBackdrop = () => {
//     setOpen((prev) => !prev);
//   };

//     return (
//         <Backdrop
//             // sx={{ color: '#fff', zIndex: 1301 }}
//             open={open}
//             className={class.customBackdrop}

//                 // className={customBackdrop}
//                 onClick={toggleBackdrop} // Fecha o Backdrop ao clicar
            
//         >
//             <CircularProgress color="inherit" />
//         </Backdrop>);
// }
// export default CustomBackdrop;